import React from "react";
import { Grid, Typography, TextField, Paper } from "@mui/material";

export default function TotalForm({
  descripcion,
  setDescripcion,
  totals,
  iva15,
  iva5,
  ice,
  total,
  readOnly = false,
}) {
  const disabledSx = {
    "& .Mui-disabled": {
      backgroundColor: "#f0f0f0 !important",
      color: "#333 !important",
      WebkitTextFillColor: "#333 !important",
    },
  };

  const canEdit = !readOnly && typeof setDescripcion === "function";

  return (
    <Grid container spacing={3} sx={{ mt: 3 }}>
      <Grid item xs={12} md={8}>
        <Typography sx={{ mb: 1 }}>
          Descripción: <span style={{ color: "red" }}>*</span>
        </Typography>
        <TextField
          value={descripcion || ""}
          onChange={canEdit ? (e) => setDescripcion(e.target.value) : undefined}
          multiline
          minRows={4}
          fullWidth
          disabled={!canEdit}
          sx={!canEdit ? disabledSx : undefined}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Paper sx={{ p: 2, backgroundColor: "#f8f9fa" }}>
          <Grid container spacing={1}>
            {[
              ["Subtotal 15%", totals?.sub15],
              ["Subtotal 5%", totals?.sub5],
              ["Subtotal 0%", totals?.sub0],
              ["Descuento", totals?.descuento],
              ["IVA 15%", iva15],
              ["IVA 5%", iva5],
              ["ICE", ice],
              ["Total", total],
            ].map(([label, value], index) => (
              <React.Fragment key={index}>
                <Grid item xs={7}>
                  <Typography
                    sx={{
                      color: "#333",
                      fontWeight: label === "Total" ? "bold" : "normal",
                    }}
                  >
                    {label}:
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    value={`$${Number(value || 0).toFixed(2)}`}
                    fullWidth
                    size="small"
                    disabled
                    sx={disabledSx}
                  />
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
